<template>
  <div class="login-region">
    <div class="wrap">
      <!-- 左上角折角切换徽章 -->
      <div
        class="switch-corner"
        @click="toggleLoginType"
        :title="
          loginType === 'password' ? '切换为扫码登录' : '切换为账号密码登录'
        "
      >
        <div class="corner-bg"></div>
        <i
          :class="
            loginType === 'password' ? 'el-icon-full-screen' : 'el-icon-monitor'
          "
        ></i>
      </div>

      <!-- 公共Logo区域 -->
      <div class="logo-box">
        <img class="logo" src="../assets/logo_login@2x.png" />
      </div>

      <!-- 动态标题 -->
      <div class="title">
        {{ loginType === "qr" ? "丽妍常管理后台" : "丽妍常管理后台"
        }}{{ isTestingEnv ? " (测试)" : "" }}
      </div>

      <!-- 微信扫码登录界面 -->
      <div class="QR-box-inner" v-if="loginType === 'qr'">
        <div class="QR-container" v-if="QR">
          <img class="QR" :src="QR" />
          <div :class="['QR-mask', { expired: isExpired }]" @click="refreshQR">
            <i class="el-icon-refresh"></i>
            <span>{{ isExpired ? "二维码已失效" : "刷新二维码" }}</span>
            <span>点击刷新</span>
          </div>
        </div>
        <div class="QR-tips">请使用企业微信扫码登录</div>
      </div>

      <!-- 账号密码登录界面 -->
      <div class="password-box-inner" v-else>
        <div class="input-wrap">
          <el-input
            type="text"
            v-model="mobile"
            placeholder="请输入手机号"
            @blur="checkMobileBlur"
            autofocus
            autocomplete="off"
          ></el-input>
          <div class="errMsg-box" v-if="mobileError">{{ mError }}</div>
        </div>

        <div class="input-wrap">
          <el-input
            type="password"
            v-model="password"
            placeholder="请输入密码"
            @blur="passwordBlur"
            autocomplete="new-password"
          ></el-input>
          <div class="errMsg-box" v-if="passwordError">{{ pError }}</div>
        </div>

        <el-button type="primary" @click.native="login" :loading="loading"
          >登录</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { login, oauth2AuthorizeUrl, scanResult } from "@/common/api";
import QRCode from "qrcode";

export default {
  name: "login",
  data() {
    return {
      isTestingEnv: window.location.origin === "http://admin.test.lienjang.cn",
      loading: false, // 登录loading
      crmUserMobile: "", // 手机号
      crmUserName: "", // 用户名
      mobileError: false, // 控制手机号报错
      passwordError: false, // 控制密码报错
      mobile: "", // 手机号检测值
      password: "", // 密码检测值
      mError: "", // 手机号报错文本
      pError: "", // 密码报错文本
      QR: "", // 二维码图片 Base64
      state: "", // 微信登录的 state 参数
      pollingTimer: null, // 扫码检测轮询定时器
      expireTimer: null, // 二维码 5 分钟失效定时器
      isExpired: false, // 二维码是否已失效
      loginType: "password", // 当前登录模式：'password' (账号密码) 或 'qr' (企业微信扫码)
    };
  },
  mounted() {
    this.getOauth2AuthorizeUrl();
    // document.body.style.overflow = "hidden";
  },
  beforeDestroy() {
    this.stopPolling();
    // document.body.style.overflow = "";
  },
  methods: {
    // 获取微信登录授权链接
    getOauth2AuthorizeUrl() {
      this.isExpired = false;
      this.stopPolling();
      oauth2AuthorizeUrl().then((res) => {
        if (res && res.data) {
          this.state = res.data.state;
          QRCode.toDataURL(res.data.url, {
            width: 180,
            margin: 2,
          })
            .then((url) => {
              this.QR = url;
              // 仅在当前为扫码界面下才激活轮询检测
              if (this.loginType === "qr") {
                this.startPolling();
              }

              // 开启 5 分钟失效计时器
              this.expireTimer = setTimeout(() => {
                this.isExpired = true;
                this.stopPolling(); // 失效后自动断开轮询
              }, 5 * 60 * 1000);
            })
            .catch((err) => {
              console.error("生成二维码失败", err);
            });
        }
      });
    },

    // 开始轮询扫码结果
    startPolling() {
      this.stopPolling();
      this.pollingTimer = setInterval(() => {
        this.scanResult();
      }, 1000);
    },

    // 停止所有定时器（扫码轮询及失效倒计时）
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
      if (this.expireTimer) {
        clearTimeout(this.expireTimer);
        this.expireTimer = null;
      }
    },

    // 登录成功后的公共存储与路由跳转
    handleLoginSuccess(data) {
      this.stopPolling();
      this.crmUserMobile = data.mobile;
      this.crmUserName = data.name;
      localStorage.setItem("crmUserSid", data.sid);
      localStorage.setItem("crmUserToken", data.token);
      localStorage.setItem("crmUserMobile", this.crmUserMobile);
      localStorage.setItem("crmUserName", this.crmUserName);
      localStorage.setItem("agentType", data.agentType);
      localStorage.setItem("companyId", data.companyId);
      this.$message({ message: "登录成功", type: "success" });
      this.$router.replace({ path: "/" });
    },

    // 查询是否扫码成功
    scanResult() {
      if (!this.state) return;
      scanResult({ state: this.state })
        .then((res) => {
          if (res && res.code == 0 && res.data) {
            this.handleLoginSuccess(res.data);
          }
        })
        .catch((err) => {
          console.error("轮询扫码结果异常", err);
        });
    },

    // 刷新二维码
    refreshQR() {
      this.getOauth2AuthorizeUrl();
    },

    // 切换登录方式
    toggleLoginType() {
      if (this.loginType === "password") {
        this.loginType = "qr";
        if (!this.QR || this.isExpired) {
          this.getOauth2AuthorizeUrl();
        } else {
          this.startPolling();
        }
      } else {
        this.loginType = "password";
        this.stopPolling();
      }
    },

    // 验证手机号
    validateMobile() {
      if (!this.mobile) {
        this.mError = "*请输入手机号";
        this.mobileError = true;
        setTimeout(() => {
          this.mobileError = false;
        }, 3000);
        return false;
      }
      this.mobileError = false;
      return true;
    },

    // 验证密码
    validatePassword() {
      if (!this.password) {
        this.pError = "*密码不能为空";
        this.passwordError = true;
        setTimeout(() => {
          this.passwordError = false;
        }, 3000);
        return false;
      }
      this.passwordError = false;
      return true;
    },

    // 输入框失焦校验
    checkMobileBlur() {
      this.validateMobile();
    },
    passwordBlur() {
      this.validatePassword();
    },

    // 常规账号密码登录
    login() {
      if (!this.validateMobile() || !this.validatePassword()) {
        return;
      }

      const params = {
        mobile: this.mobile,
        password: this.password,
      };

      this.loading = true;
      login(params)
        .then((res) => {
          this.loading = false;
          if (res.code == 0) {
            this.handleLoginSuccess(res.data);
          } else {
            this.$message({ message: res.msg, type: "error" });
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("服务器异常");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../common/styles/base/mixin-font";
@import "../common/styles/base/mixin-common";

.login-region {
  @include position(fixed, 1000, 0, 0, 0, 0);
  overflow: auto;
  display: flex;
  padding: 20px;
  box-sizing: border-box;

  .wrap {
    width: 650px;
    flex-shrink: 0;
    position: relative;
    z-index: 1001;
    margin: auto;
    background: $colorWhite;
    padding: 45px 94px;
    border-radius: 12px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    height: 642px; /* 固定卡片高度，消除切换登录方式时的 4px 高度微调与抖动 */
    box-sizing: border-box;

    // 左上角折角切换徽章
    .switch-corner {
      position: absolute;
      top: 0;
      left: 0;
      width: 80px;
      height: 80px;
      cursor: pointer;
      overflow: hidden;
      z-index: 1010;

      .corner-bg {
        position: absolute;
        top: -40px;
        left: -40px;
        width: 80px;
        height: 80px;
        background: #a18965;
        transform: rotate(45deg);
        transition: background 0.3s;
      }

      i {
        position: absolute;
        top: 10px;
        left: 10px;
        font-size: 26px;
        color: #ffffff;
        transition: transform 0.3s;
      }

      &:hover {
        .corner-bg {
          background: lighten(#a18965, 8%);
        }
        i {
          transform: scale(1.1);
        }
      }
    }

    // 微信扫码登录排版
    .QR-box-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 460px;

      .QR-container {
        position: relative;
        width: 180px;
        height: 180px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 24px;
        border: 1px solid #eaeaea;
        padding: 4px;
        border-radius: 4px;
        background: #ffffff;

        .QR {
          width: 100%;
          height: 100%;
        }

        .QR-mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, 0.92);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #333333;
          font-size: 14px;
          transition: opacity 0.3s, background 0.3s;
          opacity: 0; /* 默认隐藏 */
          pointer-events: none; /* 默认不响应鼠标，以免遮挡微信扫码 */

          &.expired {
            opacity: 1;
            pointer-events: auto;
          }

          .el-icon-refresh {
            font-size: 32px;
            color: #222222;
            margin-bottom: 8px;
            transition: transform 0.4s ease;
          }

          span {
            font-weight: 500;
            line-height: 20px;
            &:last-child {
              font-size: 12px;
              color: #999999;
              margin-top: 2px;
            }
          }
        }

        &:hover {
          .QR-mask {
            opacity: 1;
            pointer-events: auto;
            background: rgba(255, 255, 255, 0.92);

            &:hover {
              background: rgba(255, 255, 255, 0.96);
              .el-icon-refresh {
                transform: rotate(180deg);
              }
            }
          }
        }
      }

      .QR-tips {
        font-size: 14px;
        color: #666666;
        font-weight: 500;
        text-align: center;
      }
    }

    // 账号密码登录排版
    .password-box-inner {
      width: 460px;
    }

    .logo-box {
      width: 276px;
      height: 200px;
      margin: 0 auto;

      .logo {
        width: 100%;
        height: 100%;
      }
    }

    .title {
      margin: 16px auto 16px;
      font-size: 40px;
      color: $textColor;
      line-height: 56px;
      text-align: center;
    }

    .input-wrap {
      position: relative;
      margin-bottom: 28px;

      .el-input {
        display: block;
        width: 460px;
      }

      .errMsg-box {
        @include position(absolute, 3, 100%, none, none, 0);
        white-space: nowrap;
        font-size: 12px;
        color: #ff614c;
        line-height: 16px;
        margin-top: 4px;
      }
    }

    .el-button {
      width: 460px;
      height: 60px;
      font-size: 18px;
      background-color: #222222;
      border-color: #222222;

      &:hover {
        opacity: 0.8;
      }

      &:active {
        opacity: 0.9;
      }
    }
  }
}
</style>
